import React from 'react';
import { useEffectOnce } from 'usehooks-ts';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { Card, Button } from 'react-bootstrap';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';

import i18n from '@components/i18n';
import { FormGroupControl } from '@components/Base';
import { otpUserFetch, passwordUpdate } from './action';
import { selectOtpToken } from './selector';
import { UserAvatar } from '@components/Feature/User/user-avatar';
import { ServerError } from '@components/Helper';

const GROUP_PROPS = { className: 'mb-3' };

const validationSchema = Yup.object({
  password: Yup.string()
    .min(6, i18n.t('validation:min', { min: 6 }))
    .required(i18n.t('validation:required')),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password'), null], i18n.t('validation:inclusion'))
    .required(i18n.t('validation:required')),
});

const OtpToken = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user, errors } = useSelector(selectOtpToken);
  const { otpToken } = useParams();
  const initialValues = { otpToken, password: '', passwordConfirmation: '' };

  useEffectOnce(() => {
    dispatch(otpUserFetch({ otpToken }));
  });

  return (
    <Card>
      <Card.Header className="text-center">
        <UserAvatar />
      </Card.Header>
      <Card.Body>
        <Card.Title>
          {<Trans i18nKey="otp.updatePasswordFor" values={{ mobileNumber: user?.mobileNumber }} />}
        </Card.Title>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            dispatch(passwordUpdate(values));
            setSubmitting(false);
          }}
        >
          {({ isSubmitting, isValid }) => (
            <Form>
              <FormGroupControl type="hidden" name="otpToken" groupProps={GROUP_PROPS} />

              <FormGroupControl
                required
                type="password"
                name="password"
                label={t('common:password')}
                groupProps={GROUP_PROPS}
              />

              <FormGroupControl
                required
                type="password"
                name="passwordConfirmation"
                label={`${t('common:confirm')} ${t('common:password')}`}
                groupProps={GROUP_PROPS}
              />

              <Button type="submit" disabled={!isValid || isSubmitting}>
                {`${t('common:update')} ${t('common:password')}`}
              </Button>

              <ServerError errors={errors} />
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};

export { OtpToken };
